import { ClientFormPage } from "~/pages/ClientFormPage";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/clients/create")({
  component: RouteComponent,
});

function RouteComponent() {
  useBreadCrumbs([
    { title: "Clients", link: `/${location.pathname.split("/")[1]}/data/clients` },
    { title: "Create", link: `/${location.pathname.split("/")[1]}/data/clients/create` },
  ]);
  return <ClientFormPage />;
}
